import {
    BrowserRouter as Router,
    Route,
    Switch,
    Redirect,
} from "react-router-dom";

import { useSetRecoilState } from "recoil";
import { SkeletonTheme } from "react-loading-skeleton";

import Header from "./views/Header/Header";
import Main from "./views/main/Main";
import Stake from "./views/stake/Stake";

import "./App.scss";
import Trade from "./views/Trade/Trade";
import ConnectWay from "./views/ConnectWay/ConnectWay";

import Campaigns from "./views/Campaigns/Campaigns";
import CampaignDetail from "./views/Campaigns/detail/CampaignDetail";

import Footer from "./views/Footer/Footer";

import GovernancePollDetail from "./views/Governance/GovernancePollDetail";
import GovernanceVote from "./views/Governance/GovernanceVote";
import GovernanceCreate from "./views/Governance/GovernanceCreate";
import GovernanceCreateForm from "./views/Governance/CreateForm/GovernanceCreateForm";

import ScrollToTop from "./libs/ScrollToTop";

import StakeGovernance from "./views/stake/gov/StakeGovernance";
import StakeLp from "./views/stake/lp/StakeLp";
import History from "./views/History/History";

import Producer from "./views/Producer/Producer";
import ProducerCreate from "./views/Producer/Create/ProducerCreate";
import ProducerSetting from "./views/Producer/Setting/ProducerSetting";
import ProducerDepositWithdraw from "./views/Producer/DepositWithdraw/ProducerDepositWithdraw";
import ProducerDetail from "./views/Producer/detail/ProducerDetail";
import ProducerSettingQualification from "./views/Producer/Setting/SettingForm/ProducerSettingQualification";
import ProducerSettingGeneral from "./views/Producer/Setting/SettingForm/ProducerSettingGeneral";
import ProducerSettingActivation from "./views/Producer/Setting/SettingForm/ProducerSettingActivation";

import { setNetwork } from "./libs/storage";
import { useEffect, useState } from "react";
import { walletState } from "./libs/contexts";
import {
    useConnectedWallet,
    useWallet,
    WalletStatus,
} from "@terra-money/wallet-provider";
import Vp from "./views/VP/VPMain";
import Mypage from "./views/Mypage/Mypage";
import ProducerSettingRegisterQualifier from "./views/Producer/Setting/SettingForm/ProducerSettingRegisterQualifier";
import Test from "./views/Test/Test";

export const PATHS = {
    home: "/",

    // stake: "/stake",
    stakeLp: "/stake/lp",
    stakeGov: "/stake/gov",

    trade: "/trade",
    test: "/test",
    connect: "/connect",
    campaigns: "/campaigns",
    campaignsDetail: "/campaigns/",

    history: "/history",

    governance: "/governance",
    governancePollDetail: "/governance/poll/",
    governanceVote: "/governance/vote",
    governanceCreate: "/governance/create",
    governanceCreateForm: "/governance/create_form",

    mypage: "/mypage",

    producer: "/creator",
    producerDetail: "/creator/campaigns/",
    producerCreate: "/creator/create",

    producerSetting: "/creator/setting",

    producerSettingQualification: "/creator/setting/qualification",
    producerSettingGeneral: "/creator/setting/general",
    producerSettingActivation: "/creator/setting/activate",
    producerSettingRegisterQualifier: "/creator/setting/register_qualifier",

    producerDepositWithdraw: "/creator/dw",

    vp: "/vp",

    // tptpublic: "/tptpublic",
};

export default function App() {
    const { status, network } = useWallet();
    const { disconnect } = useWallet();
    const connectedWallet = useConnectedWallet();
    const [initialized, setInitialized] = useState(false);
    const setWallet = useSetRecoilState(walletState);

    useEffect(() => {
        if (status !== WalletStatus.INITIALIZING) {
            setNetwork(network);

            const obj = connectedWallet
                ? { terraAddress: connectedWallet.terraAddress }
                : undefined;

            setWallet(obj);
            setInitialized(true);
        } else {
            setInitialized(false);
        }
    }, [status, network, connectedWallet, setWallet]);

    if (!initialized) {
        return <div />;
    }

    if (network.name === "classic") {
        disconnect();
        window.location.replace("https://classic-app.valkyrieprotocol.com/");
    }

    return (
        <SkeletonTheme
            baseColor="rgba(63,70,87, 0.4)"
            highlightColor="rgba(175,188,212,0.4)"
        >
            <Router>
                <ScrollToTop />
                <div className="app_container">
                    <Header />
                    <div className="bg_container">
                        <Switch>
                            <Route
                                exact
                                path={PATHS.home}
                                render={(props: any) => {
                                    return <Main {...props} />;
                                }}
                            />

                            <Route
                                exact={true}
                                path={PATHS.governance}
                                render={(props: any) => {
                                    return <Stake {...props} />;
                                }}
                            />
                            <Route
                                exact={true}
                                path={PATHS.stakeLp}
                                render={(props: any) => {
                                    return <StakeLp {...props} />;
                                }}
                            />
                            <Route
                                exact={true}
                                path={PATHS.stakeGov}
                                render={(props: any) => {
                                    return <StakeGovernance {...props} />;
                                }}
                            />
                            <Route
                                path={PATHS.trade}
                                render={(props: any) => {
                                    return <Trade {...props} />;
                                }}
                            />
                            <Route
                                path={PATHS.test}
                                render={(props: any) => {
                                    return <Test {...props} />;
                                }}
                            />
                            <Route
                                path={PATHS.connect}
                                render={(props: any) => {
                                    return <ConnectWay {...props} />;
                                }}
                            />
                            <Route
                                exact={true}
                                path={PATHS.campaigns}
                                render={(props: any) => {
                                    return <Campaigns {...props} />;
                                }}
                            />
                            <Route
                                exact={true}
                                path={
                                    PATHS.campaignsDetail + ":campaignAddress"
                                }
                                render={(props: any) => {
                                    return <CampaignDetail {...props} />;
                                }}
                            />

                            <Route
                                exact={true}
                                path={PATHS.history}
                                render={(props: any) => {
                                    return <History {...props} />;
                                }}
                            />
                            <Route
                                exact={true}
                                path={PATHS.governanceCreate}
                                render={(props: any) => {
                                    return <GovernanceCreate {...props} />;
                                }}
                            />
                            <Route
                                exact={true}
                                path={PATHS.governanceCreateForm}
                                render={(props: any) => {
                                    return <GovernanceCreateForm {...props} />;
                                }}
                            />

                            <Route
                                exact={true}
                                path={PATHS.producer}
                                render={(props: any) => {
                                    return <Producer {...props} />;
                                }}
                            />
                            <Route
                                exact={true}
                                path={PATHS.producerCreate}
                                render={(props: any) => {
                                    return <ProducerCreate {...props} />;
                                }}
                            />
                            <Route
                                exact={true}
                                path={PATHS.producerSetting}
                                render={(props: any) => {
                                    return <ProducerSetting {...props} />;
                                }}
                            />

                            <Route
                                exact={true}
                                path={PATHS.producerSettingQualification}
                                render={(props: any) => {
                                    return (
                                        <ProducerSettingQualification
                                            {...props}
                                        />
                                    );
                                }}
                            />

                            <Route
                                exact={true}
                                path={PATHS.producerSettingRegisterQualifier}
                                render={(props: any) => {
                                    return (
                                        <ProducerSettingRegisterQualifier
                                            {...props}
                                        />
                                    );
                                }}
                            />

                            <Route
                                exact={true}
                                path={PATHS.producerSettingGeneral}
                                render={(props: any) => {
                                    return (
                                        <ProducerSettingGeneral {...props} />
                                    );
                                }}
                            />

                            <Route
                                exact={true}
                                path={PATHS.producerSettingActivation}
                                render={(props: any) => {
                                    return (
                                        <ProducerSettingActivation {...props} />
                                    );
                                }}
                            />

                            <Route
                                exact={true}
                                path={PATHS.producerDepositWithdraw}
                                render={(props: any) => {
                                    return (
                                        <ProducerDepositWithdraw {...props} />
                                    );
                                }}
                            />

                            <Route
                                path={PATHS.producerDetail + ":campaignAddress"}
                                render={(props: any) => {
                                    return <ProducerDetail {...props} />;
                                }}
                            />
                            <Route
                                path={PATHS.governancePollDetail + ":pollId"}
                                render={(props: any) => {
                                    return <GovernancePollDetail {...props} />;
                                }}
                            />

                            <Route
                                exact={true}
                                path={PATHS.governanceVote}
                                render={(props: any) => {
                                    return <GovernanceVote {...props} />;
                                }}
                            />

                            <Route
                                exact={true}
                                path={PATHS.vp}
                                render={(props: any) => {
                                    return <Vp {...props} />;
                                }}
                            />

                            <Route
                                exact={true}
                                path={PATHS.mypage}
                                render={(props: any) => {
                                    return <Mypage {...props} />;
                                }}
                            />

                            <Redirect from="/*" to={PATHS.home} />
                        </Switch>
                    </div>
                    <Footer />
                    {/* {isV2 && !closed ? (
                        <div className={"v2_popup_container"}>
                            <div className="v2_popup">
                                <div className="v2_text1">{"Guide"}</div>
                                <div className="v2_text2">
                                    {
                                        'Valkyrie Protocol has not launched on "Terra V2" yet.'
                                    }
                                    <br />
                                    <br />
                                    {
                                        'Change network to "Classic" on Chrome Extension.'
                                    }
                                </div>

                                <div className="v2_button">
                                    <YellowButton
                                        title={"Check"}
                                        onClick={() => {
                                            setClosed(true);
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                    ) : (
                        <div />
                    )} */}
                </div>
            </Router>
        </SkeletonTheme>
    );
}
